<template>
 <div :class="windowClass">
        <v-row no-gutters class="ma-2">
            <v-col cols="12">
              <v-card>
                <v-toolbar dense>
                  <v-icon left color="secondary">mdi-bottle-soda-classic</v-icon>  Products
                  <v-spacer/>
                  <span style="width: 250px;" class="mt-6">
                        <v-text-field
                        v-model="search"
                        label="Search"
                        solo
                        @focus="search=''"
                        append-icon="mdi-magnify"
                        dense
                        />
                  </span>
                  <v-icon right large color="secondary"  @click="state='new',product={},form=true">mdi-plus-box</v-icon>
                </v-toolbar>
                  <v-data-table
                    class="va-table mt-4"
                    dense
                    :headers="headers"
                    :search="search"
                    :items="PRODUCTS"
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                                <td><v-icon @click="state='update',product=item,form=true" x-small left color="warning">mdi-pencil</v-icon> 
                                {{item.code}} <span class="sm-font text-info"> {{item.empty_component}} </span>
                                </td>
                                <td><span  class="md-font"> {{item.description}} </span></td>
                                <td>{{item.cat_name}}</td>
                                 <td>{{$money(item.price_per_unit)}} <span class="sm-font"> x {{item.num_item_per_unit}} </span> </td>
                                <td>{{item.type}}<br /><span class="md-font">Size:  {{item.size_type}}</span></td>
                                <td>{{item.volume}} m&sup3; | {{item.weight}} kg</td>
                                 <td>{{item.supplier_name}}</td>
                                 <td>{{item.sort}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-4">
                <v-card>
                <v-toolbar dense>
                  <v-icon left color="secondary">mdi-bottle-soda-classic</v-icon>  Categories
                  <v-spacer/>
                  
                  <v-icon right large color="secondary" @click="state='new',catform=true">mdi-plus-box</v-icon>
                </v-toolbar>
                  <v-data-table
                    class="va-table mt-4"
                    dense
                    :headers="catheaders"
                    :items="categories"
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                                <td>
                                  <v-icon @click="state='update',category=item,catform=true" x-small left color="warning">mdi-pencil</v-icon>
                                  {{item.name}}</td>
                                <td>{{item.description}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
              </v-card>
            </v-col>
        </v-row>
        <va-product-form :show="form" :item="product" :state="state" @DialogEvent="formEvent"/>
        <va-category-form :show="catform" :category="category" :state="state" @DialogEvent="categoryEvent"/>
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      catform: false,
      form: false,
      state:'',
      search:"",
      product:{},
      category:{},
     headers: [
          { text: 'Code', value: 'code' },
          { text: 'Description', value: 'description' },
           { text: 'Category', value: 'cat_name' },
          { text: 'Price/Unit', value: 'price_per_unit' },
          { text: 'Type', value: 'type' },
          { text: 'Vol.', value: 'volume' },
             { text: 'Supplier', value: 'supplier_name' },
            { text: 'Sort', value: 'Sort' },
        ],
       catheaders: [
          { text: 'Name', value: 'name' },
          { text: 'Description', value: 'description' }
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.SET_MENUS()
          this.setLoggedIn(true) 
          this.GET_PRODUCTS()
          this.GET_CATEGORIES()
          this.GET_SUPPLIERS()
           this.GET_SETTINGS()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      categories() {
        return this.$store.state.categories
      },
      PRODUCTS(){
        return this.$store.state.products
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      categoryEvent(data){
         console.log(data) 
         this.catform = false
           this.GET_CATEGORIES()
      },
      formEvent() {
        this.form = false
         this.GET_PRODUCTS()
      }
      
    },
  }
</script>